export const CopyIcon = ({ size = 18, strokeColor = "#D1D5DC", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clip-path="url(#clip0_4753_17175)">
      <path
        d="M13.333 5.33325H6.66634C5.92996 5.33325 5.33301 5.93021 5.33301 6.66659V13.3333C5.33301 14.0696 5.92996 14.6666 6.66634 14.6666H13.333C14.0694 14.6666 14.6663 14.0696 14.6663 13.3333V6.66659C14.6663 5.93021 14.0694 5.33325 13.333 5.33325Z"
        stroke={strokeColor}
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.66634 10.6666C1.93301 10.6666 1.33301 10.0666 1.33301 9.33325V2.66659C1.33301 1.93325 1.93301 1.33325 2.66634 1.33325H9.33301C10.0663 1.33325 10.6663 1.93325 10.6663 2.66659"
        stroke={strokeColor}
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4753_17175">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
